import { Component } from 'react'
// TODO: move selectAllDevices selectors to hoc selector
import { selectAllDevices } from 'containers/DeviceSlider/selectors'
import { connect } from 'react-redux'

const DeviceNameHOC = (WrappedComponent) => {
  class DeviceName extends Component {
    deviceName = (id, hideParens = false) => {
      const device = this.props.devices.find(
        (device) => device.id === parseInt(id, 10)
      )
      if (device) {
        return hideParens ? device.name : `(${device.name})`
      }
    }

    generateProps = () => ({
      ...this.props,
      deviceName: this.deviceName
    })

    render() {
      return <WrappedComponent {...this.generateProps()} />
    }
  }

  const mapStateToProps = (state) => ({ devices: selectAllDevices(state) })

  return connect(mapStateToProps)(DeviceName)
}

export default DeviceNameHOC
